/**
 * ReportsHarvestInspectionPickTypeName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    pickTypeName?: ?string;
}

export class ReportsHarvestInspectionPickTypeName extends React.PureComponent<Props> {
    render() {
        const { pickTypeName } = this.props;
        if (!pickTypeName) return null;
        return pickTypeName;
    }
}

const mapStateToProps = createStructuredSelector({
    pickTypeName: makeSelectReportsHarvestInspectionValue('pickTypeName')
});

export default connect(mapStateToProps)(ReportsHarvestInspectionPickTypeName);
